import { useEventBasedExtraServices } from "@lib/logic";
import { useTranslation } from "react-i18next";
import { AllExtraServicesSelectionCard } from "../AllExtraServicesSelectionCard";
import { StyledAnimatedButton, StyledWrapper } from "../../eventDetails/MeetingDetailsCard/styles";
import { useModal } from "@hooks";
import { pxToRem } from "@utils";
import { P } from "@quarks";
import { Icon, ThreeColumnCell } from "@atoms";

type Props = {
  meetingId: string;
};

export const ExtraServicesTile = ({ meetingId }: Props) => {
  const { t } = useTranslation();
  const { addPages, openModal, removePages } = useModal();

  const { highlightedServicesCount, highlightedServices } = useEventBasedExtraServices(meetingId);

  if (!highlightedServicesCount) return <></>;

  const handleOnClick = () => {
    addPages([
      <AllExtraServicesSelectionCard
        category="EventBased"
        whitelistedBuidlings={Object.keys(highlightedServices)}
        onBack={() => removePages(1)}
        meetingId={meetingId}
        locationName={undefined}
        selectedDate={undefined}
      />,
    ]);
    openModal();
  };

  return (
    <StyledWrapper>
      <StyledAnimatedButton
        role="button"
        tabIndex={0}
        onClick={handleOnClick}>
        <ThreeColumnCell
          left={
            <Icon
              icon="extras"
              size={pxToRem(24)}
            />
          }
          middle={<P>{t("AddServices")}</P>}
          padding="small"
          right={
            <Icon
              icon="caretRight"
              size={pxToRem(24)}
            />
          }
          separator={false}
        />
      </StyledAnimatedButton>
    </StyledWrapper>
  );
};
